<div class="m-2">
  <button pButton type="button" class="p-button-raised p-button-danger p-button-sm ml-1 buttonBack" (click)="voltar()"
    icon="fa fa-reply" pTooltip="{{'rmpv.produtividade.returnMainPage' | translate}}" tooltipStyleClass="tooltipSize"></button>
  <button translate pButton type="button" class="p-button-raised p-button-secondary p-button-sm ml-1"
    (click)="getAll()">
    <i class="fas fa-search mr-1"></i>{{'vorPCA.buscarDados'}}
  </button>
  <button pButton type="button" class="p-button-outlined p-button-secondary p-button-sm pull-right"
    (click)="exportExcel()">
    <i class="fa fa-download mr-1"></i>Export Excel
  </button>
</div>
<app-loading [exibir]="carregando"></app-loading>
<div class="conteiner-fluid cartoes">
  <div class="structure">
    <div class="structure divided-first">
      <div class="caixa h-100 shadow">
        <div class="row">
          <div class="col col-lg-4">
            <div class="card card-social">
              <div class="card-block border-bottom">
                <div class="row align-items-center justify-content-center">
                  <div class="col-auto">
                    <em class="far fa-clock fa-3x"></em>
                  </div>
                  <div class="col text-right">
                    <h4 translate class="text-right"
                      pTooltip="{{'rmpv.produtividade.legendaProdutividade' | translate}}" tooltipPosition="top"
                      tooltipStyleClass="tooltipSize">
                      {{'rmpv.produtividade.produtividadeCard'}}
                    </h4>
                    <h5 class="text-c-green"><strong> +
                        <ngx-odometer [number]="produtividade" [config]="configShowNumber" class="text-c-green">
                        </ngx-odometer> %</strong>
                      <span translate class="text-muted">{{'rmpv.produtividade.ideal'}}</span>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="card-block">
                <div class="row align-items-center justify-content-center card-active">
                  <div class="col-6">
                    <h3 translate class="text-center  m-b-10">
                      <strong>{{produtividadeHT | number: '1.2-2'}}%</strong>
                    </h3>
                    <div class="progress">
                      <div class="progress-bar progress-c-theme" role="progressbar" [ngStyle]="{width: produtividadeHTStrg}"
                        aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="structure divided-second">
      <div class="caixa h-100 shadow">
        <div class="row">
          <div class="col col-lg-4">
            <div class="card card-social">
              <div class="card-block border-bottom">
                <div class="row align-items-center justify-content-center">
                  <div class="col-auto">
                    <em class="fas fa-tachometer-alt fa-3x"></em>
                  </div>
                  <div class="col text-right">
                    <h4 translate class="text-right" pTooltip="{{'rmpv.produtividade.legendaEficiencia' | translate}}"
                      tooltipPosition="top" tooltipStyleClass="tooltipSize">
                      {{'rmpv.produtividade.eficienciaCard'}}
                    </h4>
                    <h5 class="text-c-purple"><strong>+
                        <ngx-odometer [number]="eficiencia" [config]="configShowNumber" class="text-c-purple">
                        </ngx-odometer> %</strong>
                      <span translate class="text-muted">{{'rmpv.produtividade.ideal'}}</span>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="card-block">
                <div class="row align-items-center justify-content-center card-active">
                  <div class="col-6">
                    <h3 translate class="text-center  m-b-10">
                      <strong>{{eficienciaHV | number: '1.2-2'}}%</strong>
                    </h3>
                    <div class="progress">
                      <div class="progress-bar progress-c-theme" role="progressbar"
                        [ngStyle]="{width: eficienciaHVStrg}" aria-valuenow="45" aria-valuemin="0"
                        aria-valuemax="100">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="structure divided-third">
      <div class="caixa h-100 shadow">
        <div class="row">
          <div class="col col-lg-4">
            <div class="card card-social">
              <div class="card-block border-bottom">
                <div class="row align-items-center justify-content-center">
                  <div class="col-auto">
                    <em class="fas fa-chart-line fa-3x"></em>
                  </div>
                  <div class="col text-right">
                    <h4 translate class="text-right" pTooltip="{{'rmpv.produtividade.legendaUtilizacao' | translate}}"
                      tooltipPosition="top" tooltipStyleClass="tooltipSize">
                      {{'rmpv.produtividade.utilizacaoCard'}}
                    </h4>
                    <h5 class="text-c-blue"> <strong>+
                        <ngx-odometer [number]="utilizacao" [config]="configShowNumber" class="text-c-blue">
                        </ngx-odometer> %</strong>
                      <span translate class="text-muted">{{'rmpv.produtividade.ideal'}}</span>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="card-block">
                <div class="row align-items-center justify-content-center card-active">
                  <div class="col-6">
                    <h3 translate class="text-center  m-b-10">
                      <strong>{{utilizacaoHV | number: '1.2-2'}}%</strong>
                    </h3>
                    <div class="progress">
                      <div class="progress-bar progress-c-theme" role="progressbar"
                        [ngStyle]="{width: utilizacaoHVStrg}" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col">
    <strong>{{'rmpv.produtividade.legenda' | translate}}</strong>
    <div class="d-inline-flex mr-1" pTooltip="{{'rmpv.produtividade.legendaHorasTrabalhadas' | translate}}"
      tooltipPosition="top" translate>{{'rmpv.produtividade.horasTrabalhadas'}}</div>
    <div class="d-inline-flex mr-1" pTooltip=" {{'rmpv.produtividade.legendaHorasDisponiveis' | translate}} "
      tooltipPosition="top" translate>{{'rmpv.produtividade.horasDisponiveis'}}</div>
    <div class="d-inline-flex" pTooltip=" {{'rmpv.produtividade.legendaHorasVendidas' | translate}}"
      tooltipPosition="top" translate> {{'rmpv.produtividade.horasVendidas'}} </div>
  </div>
  <div class="conteudo">
    <div *ngIf="!carregando">
      <p-table [columns]="columns" [value]="data" styleClass="p-datatable-sm p-datatable-striped"
        responsiveLayout="scroll" class="style" [rowHover]="true" id="excel-table" [autoLayout]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field"
              [translate]="getTranslate(col.header)">
              {{col.header}}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-columns="columns">
          <tr>
            <td *ngFor="let col of columns">
              {{data[col.field]}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
